/* bm_peakExplorer_orderProps.js – schreibt State als Line Item Properties ins Produkt-Form */
(function () {
  window.BM = window.BM || {};
  if (window.BM.__peakExplorerOrderPropsLoaded) return;
  window.BM.__peakExplorerOrderPropsLoaded = true;

  const FORM_SELECTOR = 'form[action*="/cart/add"]';
  const FIELDS = Object.freeze([
    ['bm_print_format', 'Druckformat'],
    ['bm_print_size_cm', 'Druckgröße (cm)'],
    ['bm_world_width_km', 'Ausschnitt-Breite (km)'],
    ['bm_world_length_km', 'Ausschnitt-Länge (km)'],
    ['bm_rotation_deg', 'Ausrichtung (°)'],
    ['bm_center_lat', 'Koordinate Breite (lat)'],
    ['bm_center_lng', 'Koordinate Länge (lng)'],
    ['bm_scale_denom', 'Maßstab (1:N)'],
    ['bm_edge_km', 'Kurze Seite Welt (km)']
  ]);

  function setupOrderProps(state, rootEl = null) {
    if (!state) return null;

    const doc = rootEl?.ownerDocument || document;
    const util = window.BM.util;
    const productVariantIds = readProductVariantIds(rootEl);
    let initialWriteTimeoutId = null;

    function isRelevantForm(form) {
      if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return false;
      if (!productVariantIds.size) return true;

      const idControl = form.querySelector('[name="id"]');
      const variantId = Number(idControl?.value);
      return Number.isFinite(variantId) && productVariantIds.has(variantId);
    }

    function getRelevantForms() {
      return Array.from(doc.querySelectorAll(FORM_SELECTOR)).filter(isRelevantForm);
    }

    function ensureFieldsOn(form) {
      if (!isRelevantForm(form)) return;

      for (const [id, label] of FIELDS) {
        if (form.querySelector(`#${id}`)) continue;

        const input = doc.createElement('input');
        input.type = 'hidden';
        input.id = id;
        input.name = `properties[${label}]`;
        form.appendChild(input);
      }
    }

    function formatFixed(value, digits) {
      const number = Number(value);
      return Number.isFinite(number) ? number.toFixed(digits) : '';
    }

    function buildValues() {
      const printSizeValue = util?.formatCmValue?.(state.printSizeCm) || String(state.printSizeCm ?? '');
      const worldWidthValue = util?.formatKmValue?.(state.worldWidthKm) || String(state.worldWidthKm ?? '');
      const worldLengthValue = util?.formatKmValue?.(state.worldHeightKm) || String(state.worldHeightKm ?? '');

      return {
        bm_print_format: state.printSizeLabel || `${printSizeValue} cm`,
        bm_print_size_cm: printSizeValue,
        bm_world_width_km: worldWidthValue,
        bm_world_length_km: worldLengthValue,
        bm_rotation_deg: Math.round(Number(state.rotationDeg) || 0),
        bm_center_lat: formatFixed(state.center?.[1], 6),
        bm_center_lng: formatFixed(state.center?.[0], 6),
        bm_scale_denom: Math.round(Number(state.scaleDenom) || 0),
        bm_edge_km: formatFixed(state.worldShortEdgeKm, 3)
      };
    }

    function writeNow(targetForm = null) {
      const forms = targetForm && isRelevantForm(targetForm) ? [targetForm] : getRelevantForms();
      if (!forms.length) return;

      const values = buildValues();
      forms.forEach(form => {
        ensureFieldsOn(form);
        FIELDS.forEach(([id]) => {
          const input = form.querySelector(`#${id}`);
          if (input) input.value = String(values[id]);
        });
      });
    }

    const writeThrottled = util?.rafThrottle?.(writeNow) || writeNow;

    initialWriteTimeoutId = window.setTimeout(() => {
      initialWriteTimeoutId = null;
      writeNow();
    }, 0);

    const onSubmit = event => {
      const form = event.target;
      if (!isRelevantForm(form)) return;
      writeNow(form);
    };

    doc.addEventListener('submit', onSubmit, true);

    return {
      write: writeNow,
      writeThrottled,
      destroy: () => {
        if (initialWriteTimeoutId) {
          window.clearTimeout(initialWriteTimeoutId);
          initialWriteTimeoutId = null;
        }
        writeThrottled.cancel?.();
        doc.removeEventListener('submit', onSubmit, true);
      }
    };
  }

  function readProductVariantIds(rootEl) {
    const ids = new Set();
    const productEl = rootEl?.querySelector?.('script[type="application/json"][data-product]');
    if (!productEl?.textContent) return ids;

    try {
      const product = JSON.parse(productEl.textContent);
      product?.variants?.forEach(variant => {
        const id = Number(variant?.id);
        if (Number.isFinite(id)) ids.add(id);
      });
    } catch {
      // Ohne auswertbare Produktdaten bleibt das bisherige, dokumentweite Verhalten erhalten.
    }

    return ids;
  }

  window.BM.setupOrderProps = setupOrderProps;
})();
